import { render } from "./Senha.vue?vue&type=template&id=c3bea3f8"
import script from "./Senha.vue?vue&type=script&lang=js"
export * from "./Senha.vue?vue&type=script&lang=js"
script.render = render

export default script